<app-lessons-list
  [lessonStatus]="lesson_statuses.LESSON_COMPLETED"
  [onlyStatuses]="[lesson_statuses.LESSON_COMPLETED, lesson_statuses.LESSON_COMPLETED_NOT_FINAL]">
</app-lessons-list>